export default __webpack_public_path__ + "static/media/folder.19f52325.svg";